import axios from "axios";
import store from "../store";

const api = axios.create({
    baseURL: "https://spydify.nw.r.appspot.com/"
});

export default api;

api.interceptors.request.use(config => {
    // Automatically apply the auth header to each request
    if (store.getters.loggedIn) {
        config.headers.common = {
            Authorization: `Bearer ${store.state.accessToken}`
        };
    }
    return config;
});
